import { Clock } from "lucide-react";

export default function ResponseBadge({ className = "" }) {
  return (
    <span
      data-testid="response-badge"
      className={`inline-flex items-center gap-2 text-xs font-medium text-[#0B192C] bg-[#FF5238]/10 border border-[#FF5238]/30 px-3 py-1.5 ${className}`}
    >
      <Clock className="h-3.5 w-3.5 text-[#FF5238]" />
      Avg. response &lt; 2 hours
    </span>
  );
}
